export const version = "rlp/5.0.8";
//# sourceMappingURL=_version.js.map